export default function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.4 7.3401L16.66 4.6001C16.3024 4.2642 15.8338 4.07146 15.3433 4.05855C14.8529 4.04565 14.3748 4.21347 14 4.5301L4.99999 13.5301C4.67676 13.8561 4.4755 14.2833 4.42999 14.7401L3.99999 18.9101C3.98652 19.0566 4.00553 19.2042 4.05565 19.3425C4.10578 19.4808 4.18579 19.6063 4.28999 19.7101C4.38343 19.8028 4.49425 19.8761 4.61609 19.9259C4.73792 19.9756 4.86838 20.0009 4.99999 20.0001H5.08999L9.25999 19.6201C9.71679 19.5746 10.144 19.3733 10.47 19.0501L19.47 10.0501C19.8193 9.68107 20.0081 9.18861 19.995 8.68064C19.9818 8.17266 19.7679 7.69061 19.4 7.3401ZM16 10.6801L13.32 8.0001L15.27 6.0001L18 8.7301L16 10.6801Z"
        fill="#939292"
      />
    </svg>
  );
}
